import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { Action, Order } from 'redux/calcBot/types'
import { expNumToString, getColorStatus, numberToShort } from 'utils/utils'
import { TradeOption } from '../../components/TradeOption/TradeOption'
import { colorsEnum, theme } from '../../utils/GlobalStyles'

export const ActionItem: React.FC<Action> = props => {
  const {
    filledAmount,
    firstDate,
    secondDate,
    createdAt,
    expectedProfit,
    expectedProfitPercent,
    profit,
    tradeOptionInfo,
    logicType,
    finishedAt,
    firstPrice,
    secondPrice,
    amount,
    firstFee,
    firstFeePercent,
    secondFee,
    secondFeePercent,
    swapExchanges,
    firstStatus,
    secondStatus,
    depthTime,
    allOrders: notSortedAllOrders,
    securedPrice,
    feeSum,
  } = props
  let { firstSide } = props
  if (swapExchanges) {
    //eslint-disable-next-line
    // prettier-ignore
    firstSide = firstSide === 'BUY' ? 'SELL' : 'BUY'
  }
  const [isCancelling, setIsCancelling] = useState(false)

  useEffect(() => {
    if (isCancelling) {
      setTimeout(() => {
        setIsCancelling(false)
      }, 15000)
    }
  }, [isCancelling])
  if (!createdAt) return <div>BAD ACTION</div>
  const { firstEx, secondEx, market, secondMarket } = tradeOptionInfo[0]
  const isBuySide = firstSide === 'BUY'
  let firstActionOrder = undefined
  let secondActionOrders: Order[] = []

  // const allOrders = [...(notSortedAllOrders?.length ? notSortedAllOrders : [])].sort((prev, next) =>
  //   prev.createdAt && next.createdAt ? prev.createdAt - next.createdAt : 0
  // )
  const allOrders = [...(notSortedAllOrders?.length ? notSortedAllOrders : [])]
  firstActionOrder = allOrders && allOrders.length ? allOrders[0] : undefined
  secondActionOrders = allOrders && allOrders.length ? allOrders.slice(1) : []

  return (
    <ActionWrapper>
      <ExchangesInfo>
        <CellContainer firstCol>
          <TradeOption tradeOption={tradeOptionInfo[0]} isInAction={true} />
        </CellContainer>
      </ExchangesInfo>
      {/*<ActionsBlock>*/}
      <ActionBlock
        style={{
          background: logicType === 'LIMIT' ? theme.getColorWithOpacity(colorsEnum.yellow, 10) : theme.getColorWithOpacity(colorsEnum.green, 10),
        }}
      >
        <CellContainer>
          <ExchangeName>
            Exchange: <span>{firstActionOrder?.exchange}</span>
          </ExchangeName>
          <Type type={isBuySide ? 'BUY' : 'SELL'}>
            Type: <span>{isBuySide ? 'BUY' : 'SELL'}</span>
          </Type>
          <Price>
            Price: <span>{expNumToString(firstPrice || 0)}</span>
          </Price>
          <Amount>
            Amount: <span>{expNumToString(amount || 0)}</span>
          </Amount>
          <Filled>
            Filled: <span>{expNumToString(filledAmount || 0)}</span>
          </Filled>
          <Status status={String(firstStatus)}>
            Status: <span>{firstStatus}</span>
          </Status>
          <DateRow>
            Created at: <span>{firstDate ? new Date(firstDate).toLocaleTimeString() : '--:--:--'}</span>
            {firstDate && <DateFull>{new Date(firstDate).toLocaleDateString()}</DateFull>}
          </DateRow>

          <DateRow>
            Action type: <LogicTypeSpan logicType={logicType}>{logicType}</LogicTypeSpan>
          </DateRow>

          <Fee>
            Fee: <span>{`${firstFee?.toFixed(6) || '-'} ${market.split('/')[1]}`} </span>
          </Fee>
          <Fee>
            Fee %: <span>{`${firstFeePercent?.toFixed(4) || '-'}`} </span>
          </Fee>
          <DateRow>
            Secured price:{' '}
            <BuySellSpan isPositive={(isBuySide ? (firstPrice || 0) - (securedPrice || 0) : (securedPrice || 0) - (firstPrice || 0)) > 0}>
              {securedPrice || 0}{' '}
            </BuySellSpan>
          </DateRow>

          <DateRow>
            Between time <span>{`${depthTime ? depthTime / 1000 : depthTime !== 0 ? '-.---' : '0.000'} s`} </span>
          </DateRow>

          <SwappedExchanges>{swapExchanges ? 'Swap Exchanges' : ''}</SwappedExchanges>
          <Profit isPositive={!!expectedProfit && expectedProfit > 0} style={{ marginTop: '10px' }}>
            Expected profit: <span>{expectedProfit ? `${numberToShort(+expectedProfit.toFixed(6))} ${market.split('/')[1]}` : '---'}</span>
          </Profit>
          <Profit isPositive={!!expectedProfitPercent && expectedProfitPercent > 0}>
            Expected profit%: <span>{+(expectedProfitPercent || 0).toFixed(2)}%</span>
          </Profit>
          <Fee>
            Total fee: <span>{`${((firstFee || 0) + (secondFee || 0)).toFixed(4) || '-'} ${market.split('/')[1]}`} </span>
          </Fee>
          <Profit isPositive={!!profit && !!firstFee && !!secondFee && profit - firstFee - secondFee > 0}>
            Pure profit:{' '}
            <span>{profit ? `${numberToShort(+(profit - ((firstFee || 0) + (secondFee || 0))).toFixed(6))} ${market.split('/')[1]}` : '---'}</span>
          </Profit>
        </CellContainer>
      </ActionBlock>
      <ActionBlock valign="top">
        <CellContainer>
          <ExchangeName>
            Exchange: <span>{firstActionOrder?.exchange === firstEx ? secondEx : firstEx}</span>
          </ExchangeName>
          <Type type={isBuySide ? 'SELL' : 'BUY'}>
            Type: <span>{isBuySide ? 'SELL' : 'BUY'}</span>
          </Type>
          <Price>
            Price: <span>{secondPrice}</span>
          </Price>
          <Amount>
            Amount: <span>{expNumToString(filledAmount || 0)}</span>
          </Amount>
          <Filled>
            Filled: <span>{secondActionOrders?.length ? expNumToString(secondActionOrders.reduce((acc, item) => item.filled + acc, 0)) : 0}</span>
          </Filled>
          <Status status={String(secondStatus)}>
            Status: <span>{secondStatus}</span>
          </Status>
          <DateRow>
            Time: <span>{secondDate ? new Date(secondDate).toLocaleTimeString() : '--:--:--'}</span>
            {secondDate && <DateFull>{new Date(secondDate).toLocaleDateString()}</DateFull>}
          </DateRow>
          <Fee>{/*Fee: <span>{['JustSwap', 'TronTrade', 'JustSwapV2'].includes(secondExchange) ? secondFee + ' TRX' : '0.1%'}</span>*/}</Fee>
          <DateRow>
            Action type: <LogicTypeSpan logicType={logicType}>{logicType}</LogicTypeSpan>
          </DateRow>

          <Fee>
            Fee: <span>{`${secondFee?.toFixed(6) || '-'} ${secondMarket?.split('/')[1] || market.split('/')[1]}`}</span>
          </Fee>
          <Fee>
            Fee %: <span>{`${secondFeePercent?.toFixed(4) || '-'}`} </span>
          </Fee>
          <DateRow>
            Finished at: <span>{finishedAt ? new Date(finishedAt).toLocaleTimeString() : '--:--:--'}</span>
            {finishedAt && <DateFull>{new Date(finishedAt).toLocaleDateString()}</DateFull>}
          </DateRow>
          {logicType === 'LIMIT' && (
            <Fee>
              <br />
            </Fee>
          )}
          <Profit isPositive={!!profit && profit > 0} style={{ marginTop: '10px' }}>
            Profit: <span>{profit ? `${numberToShort(+profit.toFixed(6))} ${market.split('/')[1]}` : '---'}</span>
          </Profit>
          <Profit isPositive={(profit - expectedProfit) / expectedProfit > 0}>
            Delta profit:{' '}
            <span>
              {expectedProfit && profit ? `${numberToShort(+(((profit - expectedProfit) / Math.abs(expectedProfit)) * 100).toFixed(2))} %` : '---'}
            </span>
          </Profit>
          <Fee>
            Real fee: <span>{`${feeSum?.toFixed(4) || '-'} ${market.split('/')[1]}`} </span>
          </Fee>
          <Profit isPositive={!!profit && !!firstFee && !!secondFee && profit - firstFee - secondFee > 0}>
            Real pure profit: <span>{profit ? `${numberToShort(+(profit - (feeSum || 0)).toFixed(6))} ${market.split('/')[1]}` : '---'}</span>
          </Profit>
        </CellContainer>
      </ActionBlock>

      {/*</ActionsBlock>*/}
      <td valign="top">
        <CellContainer place="orders">
          <OrdersGrid>
            {allOrders &&
              allOrders.length &&
              allOrders.map((order, index, allArr) => {
                return <OrderComponent order={order} index={index} allArr={allArr} firstSide={firstSide} />
              })}
          </OrdersGrid>
        </CellContainer>
      </td>
    </ActionWrapper>
  )
}

const OrderComponent: React.FC<{ order: Order; index: number; allArr: Order[]; firstSide: string }> = ({ order, index, allArr, firstSide }) => {
  const [tradesOpened, setTradesOpened] = useState(false)
  return (
    <OrderRow
      key={order._id}
      onClick={e => {
        e.stopPropagation()
        setTradesOpened(true)
      }}
      onMouseLeave={() => setTradesOpened(false)}
    >
      <OrderCol>
        {`${order.side === firstSide ? 1 : 2} `}
        {order.exchange}
      </OrderCol>
      <OrderCol>{order.market}</OrderCol>
      <OrderCol style={{ width: '40px' }} color={order?.side?.toUpperCase() === 'BUY' ? 'green' : 'red'}>
        {order?.side?.toUpperCase()}
      </OrderCol>
      <OrderCol style={{ width: '100px' }}>{expNumToString(order.price)}</OrderCol>
      <OrderCol>{expNumToString(order.volume)}</OrderCol>
      <OrderCol style={{ overflow: 'hidden' }}>{expNumToString(order.filled)}</OrderCol>
      <OrderCol color={order.orderStatus === 'error' ? 'red' : order.isActive ? 'green' : 'yellow'}>
        {order.customId && !order.orderId
          ? 'fb'
          : order.orderId && order.isPending
          ? 'be'
          : order.orderStatus === 'error'
          ? 'failed'
          : order.isPending
          ? 'pending'
          : !order.isActive && order.filled === 0
          ? 'cancelled'
          : order.filled === order.volume
          ? 'filled'
          : order.filled > 0
          ? 'p.filled'
          : order.isActive
          ? 'active'
          : 'unknown'}
      </OrderCol>
      <OrderCol style={{ width: '100px', textAlign: 'left' }} time={true}>
        {order.createdTime ? new Date(order.createdTime).toLocaleTimeString() + '.' + new Date(order.createdTime).getMilliseconds() : '--:--:--.---'}
        {order.createdTime && <DateInfo>{new Date(order.createdTime).toLocaleDateString()}</DateInfo>}
        <TimeDiff>{index > 0 && order.createdTime && ((order.createdTime - (allArr?.[index - 1]?.createdTime || 0)) / 1000).toFixed(3)}</TimeDiff>
      </OrderCol>
      <OrderCol style={{ width: '100px', textAlign: 'left' }} time={true}>
        {order.createdInSocketTime
          ? new Date(order.createdInSocketTime).toLocaleTimeString() + '.' + new Date(order.createdInSocketTime).getMilliseconds()
          : '--:--:--.---'}
        {order.createdInSocketTime && <DateInfo>{new Date(order.createdInSocketTime).toLocaleDateString()}</DateInfo>}
        <TimeDiff>
          {index > 0 &&
            order.createdInSocketTime &&
            ((order.createdInSocketTime - (allArr?.[index - 1]?.createdInSocketTime || 0)) / 1000).toFixed(3)}
        </TimeDiff>
      </OrderCol>
      <OrderCol style={{ width: '100px', textAlign: 'left' }} time={true}>
        {order.gotOrderIdTime
          ? new Date(order.gotOrderIdTime).toLocaleTimeString() + '.' + new Date(order.gotOrderIdTime).getMilliseconds()
          : '--:--:--.---'}
        {order.gotOrderIdTime && <DateInfo>{new Date(order.gotOrderIdTime).toLocaleDateString()}</DateInfo>}
        <TimeDiff>
          {index > 0 && order.gotOrderIdTime && ((order.gotOrderIdTime - (allArr?.[index - 1]?.gotOrderIdTime || 0)) / 1000).toFixed(3)}
        </TimeDiff>
      </OrderCol>
      <OrderCol style={{ width: '100px', textAlign: 'left' }} time={true}>
        {order.deactivatedTime
          ? new Date(order.deactivatedTime).toLocaleTimeString() + '.' + new Date(order.deactivatedTime).getMilliseconds()
          : '--:--:--.---'}
        {order.deactivatedTime && <DateInfo>{new Date(order.deactivatedTime).toLocaleDateString()}</DateInfo>}
        <TimeDiff>
          {index > 0 && order.deactivatedTime && ((order.deactivatedTime - (allArr?.[index - 1]?.deactivatedTime || 0)) / 1000).toFixed(3)}
        </TimeDiff>
      </OrderCol>
      {/*<OrderCol style={{ width: '100px', textAlign: 'left' }} time={true}>*/}
      {/*  {new Date(order.date).toLocaleTimeString() + '.' + new Date(order.date).getMilliseconds()}*/}
      {/*  <DateInfo>{new Date(order.date).toLocaleDateString()}</DateInfo>*/}
      {/*  <TimeDiff>{index > 0 && order.date && ((order.date - (allArr?.[index - 1]?.date || 0)) / 1000).toFixed(3)}</TimeDiff>*/}
      {/*</OrderCol>*/}
      {/*<OrderCol style={{ width: '100px', textAlign: 'left' }} time={true}>*/}
      {/*  {order.createdAt ? new Date(order.createdAt).toLocaleTimeString() + '.' + new Date(order.createdAt).getMilliseconds() : '--:--:--.---'}*/}
      {/*  {order.createdAt && <DateInfo>{new Date(order.createdAt).toLocaleDateString()}</DateInfo>}*/}
      {/*  <TimeDiff>{index > 0 && order.createdAt && ((order.createdAt - (allArr?.[index - 1]?.createdAt || 0)) / 1000).toFixed(3)}</TimeDiff>*/}
      {/*</OrderCol>*/}
      {/*<OrderCol style={{ width: '100px', textAlign: 'left' }} time={true}>*/}
      {/*  {order.firstResponseTime*/}
      {/*    ? new Date(order.firstResponseTime).toLocaleTimeString() + '.' + new Date(order.firstResponseTime).getMilliseconds()*/}
      {/*    : '--:--:--.---'}*/}
      {/*  {order.firstResponseTime && <DateInfo>{new Date(order.firstResponseTime).toLocaleDateString()}</DateInfo>}*/}
      {/*  <TimeDiff>*/}
      {/*    {index > 0 && order.firstResponseTime && ((order.firstResponseTime - (allArr?.[index - 1]?.firstResponseTime || 0)) / 1000).toFixed(3)}*/}
      {/*  </TimeDiff>*/}
      {/*</OrderCol>*/}
      {/*<OrderCol style={{ width: '100px', textAlign: 'left' }} time={true}>*/}
      {/*  {order.updatedAt ? new Date(order.updatedAt).toLocaleTimeString() + '.' + new Date(order.updatedAt).getMilliseconds() : '--:--:--.---'}*/}
      {/*  {order.updatedAt && <DateInfo>{new Date(order.updatedAt).toLocaleDateString()}</DateInfo>}*/}
      {/*  <TimeDiff>{index > 0 && order.updatedAt && ((order.updatedAt - (allArr?.[index - 1]?.updatedAt || 0)) / 1000).toFixed(3)}</TimeDiff>*/}
      {/*</OrderCol>*/}

      <OrderId>
        {['JustSwap', 'TronTrade', 'JustSwapV2'].includes(order.exchange) ? (
          <a target="_blank" rel="noreferrer" href={`https://tronscan.io/#/transaction/${order.orderId}`}>
            Transaction
          </a>
        ) : (
          order.orderId
        )}
      </OrderId>

      {tradesOpened && (
        <Trades>
          <TradesHead>
            <TradeCol>Price</TradeCol>
            <TradeCol>Volume</TradeCol>
            <TradeCol>Type</TradeCol>
            <TradeCol>Side</TradeCol>
            <TradeCol>Time</TradeCol>
            <TradeCol>Fee Asset</TradeCol>
            <TradeCol>Fee</TradeCol>
            <TradeCol>USD Fee</TradeCol>
          </TradesHead>

          <TradesList>
            {order?.trades?.map(({ tradeId, side, maker, price, volume, time, fee, feeAsset, calculatedFee }) => (
              <Trade key={tradeId}>
                <TradeCol>{price}</TradeCol>
                <TradeCol>{volume}</TradeCol>
                <TradeCol color={maker ? 'yellow' : 'green'}>{maker ? 'maker' : 'taker'}</TradeCol>
                <TradeCol color={side === 'BUY' ? 'green' : 'red'}>{side}</TradeCol>
                <TradeCol>{new Date(time).toLocaleTimeString() + '.' + new Date(time).getMilliseconds()}</TradeCol>
                <TradeCol>{feeAsset}</TradeCol>
                <TradeCol>{fee}</TradeCol>
                <TradeCol>{calculatedFee}</TradeCol>
              </Trade>
            ))}
          </TradesList>
        </Trades>
      )}
    </OrderRow>
  )
}

const Price = styled.div``

const Filled = styled.div``

const DateFull = styled.div`
  position: absolute;
  right: -4px;
  bottom: 0;
  background: #000;
  padding: 2px 4px;
  transform: translateY(100%);
  display: none;
`
const DateRow = styled.div`
  position: relative;
  &:hover {
    ${DateFull} {
      z-index: 5;
      display: block;
    }
  }
`
const ActionWrapper = styled.tr`
  text-align: center;
`

const CellContainer = styled.div<{ place?: string; firstCol?: boolean }>`
  position: relative;
  ${({ firstCol, place }) => {
    if (firstCol) {
      return `
      padding-left: 20px;
      `
    } else {
      return `
        padding: ${place === 'orders' ? '0' : '0 10px 0 10px'}; 
        & > div {
          display: flex;
          justify-content: space-between;
        }
      `
    }
  }}
`

const ActionBlock = styled.td`
  border-bottom: 1px solid #ffffff22;
  vertical-align: top;
`

const ExchangesInfo = styled.td`
  width: 200px;
`

const Type = styled.div<{ type?: string }>`
  span {
    color: ${({ type, theme }) => (type ? (type === 'SELL' ? theme.red : theme.green) : 'white')};
  }
`
const ExchangeName = styled.div``
const Amount = styled.div``
const Status = styled.div<{ status: string }>`
  span {
    color: ${({ status }) => getColorStatus(status)};
  }
`
const Profit = styled.div<{ isPositive: boolean }>`
  span {
    color: ${({ isPositive, theme }) => (isPositive ? theme.green : theme.red)};
  }
`
const Fee = styled.div`
  span {
    color: ${({ theme }) => theme.yellow};
  }
`
const OrdersGrid = styled.div`
  display: flex;
  flex-direction: column;
  //max-height: 100px;
  &::-webkit-scrollbar {
    width: 0;
    visibility: hidden;
  }
  z-index: 1;
`
const OrderId = styled.div`
  position: absolute;
  display: none;
  bottom: 50%;
  left: 0;
  transform: translateY(50%);
  padding: 2px 4px;
  background: #000;
  z-index: 1;
  a {
    color: #fff;
  }
`

const Trades = styled.div`
  display: block;
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translateY(100%);
  z-index: 10;
  background: ${({ theme }) => theme.dark};
  border: 1px solid #ffffff44;
  border-radius: 3px;
  padding: 2px;
`

const OrderRow = styled.div`
  display: flex;
  position: relative;
  padding: 0;
  border-bottom: 1px solid #ffffff22;
  //z-index: 1;
  &:hover {
    background: #ffffff22;
    ${OrderId} {
      z-index: 10;
      display: block;
    }
  }
`

const CancelButton = styled.button`
  color: ${({ theme }) => theme.red};
  border: 1px solid ${({ theme }) => theme.red};
  border-radius: 2px;
  font-size: 14px;
  padding: 2px 4px;
  margin-bottom: 10px;
  margin-top: 17px;
  cursor: pointer;
  &:hover {
    cursor: pointer;
    background: ${({ theme }) => theme.red};
    color: ${({ theme }) => theme.dark};
  }
  &:active {
    background: ${({ theme }) => theme.getColorWithOpacity(colorsEnum.red, 65)};
    color: ${({ theme }) => theme.dark};
  }
`

const DateInfo = styled.div`
  position: absolute;
  top: 0;
  display: none;
  width: 100%;
  background: ${({ theme }) => theme.dark};
  padding: 2px;
  z-index: 10;
`

const OrderCol = styled.div<{ error?: boolean; color?: string; time?: boolean }>`
  //overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 65px;
  padding: 1px 2px;
  font-size: 10px;
  z-index: 1;
  position: relative;
  color: ${({ color, theme }) => theme.getColorByName(color)};
  ${CancelButton} {
    font-size: 12px;
    padding: 0;
    border: none;
    margin: 0;
    display: none;
    &:hover {
      color: ${({ theme }) => theme.red};
      background: none;
    }
    position: relative;
  }
  &:hover {
    cursor: pointer;
    span {
      display: ${({ error }) => (error ? 'none' : 'inline')};
    }
    ${CancelButton} {
      margin: 0;
      display: block;
    }
    ${DateInfo} {
      display: block;
    }
  }
`

export const ShowFullButton = styled.button`
  //position: absolute;
  left: 4px;
  top: 4px;
  z-index: 1;
  font-size: 11px;
  line-height: 1;
  padding: 1px 2px;
  border-radius: 2px;
  border: 1px solid ${({ theme }) => theme.getColorWithOpacity(colorsEnum.green, 30)};
  color: ${({ theme }) => theme.getColorWithOpacity(colorsEnum.green, 30)};
  &:hover {
    border: ${({ theme }) => theme.green};
    color: ${({ theme }) => theme.green};
  }
  &:active {
    color: #fff;
    background: ${({ theme }) => theme.green};
  }
`
export const SwappedExchanges = styled.div`
  border-radius: 12px;
  color: ${({ theme }) => theme.blue};
  text-align: center;
  margin: auto;
`

export const LogicTypeSpan = styled.span<{ logicType: string }>`
  color: ${({ logicType, theme }) => (logicType === 'LIMIT' ? theme.yellow : theme.green)};
`

export const TimeDiff = styled.span`
  color: ${({ theme }) => theme.red};
  margin-left: 4px;
`

const BuySellSpan = styled.span<{ isPositive: boolean }>`
  color: ${({ isPositive, theme }) => (isPositive ? theme.green : theme.red)};
`

const Trade = styled.div`
  display: flex;
`
const TradesList = styled.div``

const TradeCol = styled.div<{ color?: string }>`
  width: 100px;
  color: ${({ color, theme }) => theme.getColorByName(color)};
`
const TradesHead = styled.div`
  color: #ffffff99;
  display: flex;
`
